<template>
    <div
        data-interface-section="header-category-page"
        :class="$style.container"
    >
        <Typography
            is="h1"
            size="s"
            type="header"
            responsive
        >
            {{ props.category?.fullTitle }}
        </Typography>
        <CategoriesList :subCategories="category?.subCategories" />
    </div>
</template>
<script setup lang="ts">
import Typography from '@/components_new/Typography.vue'
import { CategoryInfo } from '@/types'

import CategoriesList from './CategoriesList.vue'

const props = defineProps<{
    category?: CategoryInfo
}>()
</script>
<style module>
.container {
    display: flex;
    flex-direction: column;
    margin-top: 4px;
}

@media (--desktop-small-plus) {
    .container {
        margin-bottom: -16px;
    }
}
</style>
